import { computed, action } from 'mobx';
import { ITranslationsCollection } from '@estee/elc-service';
import { OrderRepository } from '../repositories/OrderRepository';
import { OrderTrackingSubmittedUseCase } from '../use-cases/OrderTrackingSubmittedUseCase';

export class OrderTrackingInformationViewController {
    private orderRepository: OrderRepository;

    constructor(orderRepository: OrderRepository) {
        this.orderRepository = orderRepository;
    }

    @action
    public loaded = (translations: ITranslationsCollection) => {
        this.orderRepository.loadTranslations(translations);
    };

    @computed
    public get data() {
        const { orderInfo, orderTracking } = this.orderRepository;
        const { isLoading } = orderTracking;

        return {
            orderInfo,
            isLoading
        };
    }

    @action
    public onQueryOrder = async (orderId: string) => {
        this.orderRepository.orderTracking.setQueryOrderNumber(orderId);
        const submitUseCase = new OrderTrackingSubmittedUseCase();
        await submitUseCase.execute();
    };
}
